import { Component } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@insided/deprecated-preact-components/modal'
import Button from '@insided/control/uikit/Button'
import TaglikeDropdown, { TaglikeDropdownItem } from '@insided/control/uikit/TaglikeDropdown'
import { Role } from '@insided/deprecated-control/UserOverview/Columns'

export interface EditRoleModalProps {
  numberOfSelectedItems: number
  isOpen: boolean
  customRoles: Role[]
  selectedItems: Role[]
  onSubmit: (isAssigning: boolean) => void
  onClose: () => void
  onItemCheck: (role: Role) => void
  onItemUncheck: (role: Role) => void
}

interface State {
  isAssigning: boolean
}

const mapRolesToDropdownItems = (customRoles: Role[]): TaglikeDropdownItem[] =>
  customRoles.map(role => ({
    id: role.id,
    value: role.id,
    name: role.label
  }))

class EditRoleModal extends Component<EditRoleModalProps, State> {
  state = {
    isAssigning: true
  }

  render() {
    const {
      numberOfSelectedItems,
      selectedItems,
      isOpen,
      customRoles,
      onClose,
      onSubmit,
      onItemCheck,
      onItemUncheck
    } = this.props

    const { isAssigning } = this.state

    return (
      <Modal isOpen={isOpen} size='medium'>
        <ModalHeader
          title={`Edit custom role for ${numberOfSelectedItems} ${numberOfSelectedItems === 1 ? 'user' : 'users'}`}
          onClose={onClose}
        />
        <ModalBody>
          <div className='l assign-role-modal-body'>
            <p className='text-bold'>How would you like to proceed?</p>
            <Button
              className='radio-button'
              onClick={() => this.setState({ isAssigning: true })}
              size='medium'
              variant={isAssigning ? 'primary' : 'secondary'}
              outlined={isAssigning}
            >
              <div className='radio-button-content-wrapper'>
                Assign custom role
                <input type='radio' name='edit-role' checked={isAssigning} />
              </div>
            </Button>
            <Button
              className='radio-button'
              onClick={() => this.setState({ isAssigning: false })}
              size='medium'
              variant={isAssigning ? 'secondary' : 'primary'}
              outlined={!isAssigning}
            >
              <div className='radio-button-content-wrapper'>
                Remove custom role
                <input type='radio' name='edit-role' checked={!isAssigning} />
              </div>
            </Button>
            <p>{isAssigning ? 'Assign' : 'Remove'} a custom role {isAssigning ? 'to' : 'from'} the selected {numberOfSelectedItems === 1 ? 'user' : 'users'}.</p>
            <TaglikeDropdown
              label='Custom role'
              placeholder='Select a custom role'
              selectedItems={mapRolesToDropdownItems(selectedItems)}
              items={mapRolesToDropdownItems(customRoles)}
              onCheck={(item) => {
                const customRole = customRoles.find(role => item.id === role.id)
                if (customRole) {
                  onItemCheck(customRole)
                }
              }}
              onUncheck={(item) => {
                const customRole = customRoles.find(role => item.id === role.id)
                if (customRole) {
                  onItemUncheck(customRole)
                }
              }}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            title={`${isAssigning ? 'Assign' : 'Remove'} custom role`}
            onClick={() => onSubmit(isAssigning)}
            size='medium'
            variant='brand'
            disabled={!selectedItems.length}
          />
          <Button title='Cancel' onClick={onClose} size='medium' />
        </ModalFooter>
      </Modal>
    )
  }
}

export default EditRoleModal
